var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"af-root"},[_c('Banner'),_vm._v(" "),_c('ShopifyPage'),_vm._v(" "),(!_vm.$route.matched.length)?_c('BaseSpinnerBig'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('ModalContainer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58295fd7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/root.vue
// module id = 809
// module chunks = 0